/**
 *
 * WidgetInitHeaderDetailsSegment
 *
 */

import React, { Fragment } from "react"
import { get } from "lodash"
import WidgetResume from "../../Reports/components/WidgetResume"
import WidgetChartEnps from "../../Reports/components/SummaryWidgets/components/WidgetChartEnps"
import WidgetResponseRateReport from "../../Reports/components/SummaryWidgets/components/WidgetResponseRateReport"
import { MEASUREMENT_WIDGET_TYPE } from "../../utils/constants"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class WidgetInitHeaderDetailsSegment extends React.Component {
  setNameMetricsTotalLabel = () => {
    const { measureGeneral } = this.props
    let surveyType = get(measureGeneral, "id_survey_type", null)
    let hasLabel = get(measureGeneral, "metric_total_label", null)
    let response = "Clima laboral"
    if (surveyType === 1 && hasLabel !== null) {
      response = get(measureGeneral, "metric_total_label", null)
    }
    if (get(measureGeneral, "is_engagement", false)) {
      response = "Engagement"
    }

    return response
  }

  setTypeMeasure = () => {
    const { measureGeneral = {} } = this.props
    let typeMeasureWidget = null
    switch (measureGeneral.is_engagement) {
      case true:
        if (measureGeneral.has_enps) {
          if (measureGeneral.is_enps_engagement) {
            typeMeasureWidget = MEASUREMENT_WIDGET_TYPE.enpsAndEngagement
          } else {
            typeMeasureWidget = MEASUREMENT_WIDGET_TYPE.onlyEnps
          }
        } else {
          typeMeasureWidget = MEASUREMENT_WIDGET_TYPE.onlyEngagement
        }
        break

      case false:
        typeMeasureWidget = MEASUREMENT_WIDGET_TYPE.leadershipOrClimate
        break
    }

    return typeMeasureWidget
  }

  renderPieChart = () => {
    const { measureData, idMeasure, measureGeneral } = this.props
    return (
      <WidgetResume
        measureGeneral={measureGeneral}
        idMeasure={idMeasure}
        idDivisionSelected={undefined}
        idDivisionParent={undefined}
        className="WidgetResume boxShadow"
        measureData={measureData}
        isLeadership={false}
        selectedSegment={undefined}
        showContentEvolution={false}
        title={
          <Fragment>
            <b>{this.setNameMetricsTotalLabel()}</b>
          </Fragment>
        }
        withEmpty
      />
    )
  }

  renderWidgetResumeEnps = () => {
    const { idMeasure, measureGeneral } = this.props

    const typeMeasureWidget = this.setTypeMeasure()

    if (
      ![
        MEASUREMENT_WIDGET_TYPE.enpsAndEngagement,
        MEASUREMENT_WIDGET_TYPE.onlyEnps,
        MEASUREMENT_WIDGET_TYPE.leadershipOrClimate,
      ].includes(typeMeasureWidget)
    ) {
      return null
    }

    if (!measureGeneral.has_enps) {
      return null
    }

    return (
      
        <WidgetChartEnps
          idMeasure={idMeasure}
          measureGeneral={measureGeneral}
          idDivisionSelected={undefined}
          idDivisionParent={undefined}
          selectedSegment={undefined}
        />

    )
  }

  renderWidgetResponseRateReport = () => {
    const { measureTotal, measureGeneral, idMeasure } = this.props
    return (
      <WidgetResponseRateReport
        measureData={measureTotal}
        measureGeneral={measureGeneral}
        idMeasure={idMeasure}
        idDivisionSelected={undefined}
        idDivisionParent={undefined}
        selectedSegment={undefined}
      />
    )
  }

  render() {
    const { measureGeneral } = this.props

    return (
      <div className="measurement-details-widgets-segments">
        <div className="measurement-details-widgets-segments-with-max">
          {this.renderPieChart()}
        </div>
        {!measureGeneral.has_enps ? null : (
          <div className="measurement-details-widgets-segments-with-max">
            {this.renderWidgetResumeEnps()}
          </div>
        )}
        <div className="measurement-details-widgets-segments-with-max">
          {this.renderWidgetResponseRateReport()}
        </div>
      </div>
    )
  }
}

WidgetInitHeaderDetailsSegment.propTypes = {}

export default WidgetInitHeaderDetailsSegment
